import type {
  GetServerSidePropsContext,
} from "next"
import { HeadMetadata } from "@/components/headMetadata";
import React, { useEffect, useState } from "react";
import Container from "@/components/ui/container";
import { LayoutAccount } from "@/components/layout-account";
import AccountBannerComponent from "@/components/banner/AccountBannerComponent";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { DrupalNode } from "next-drupal";
import { drupal } from "@/lib/drupal";
import { SlideshowNodes } from "@/components/articles";
import { NodePodcastPromotedSlider } from "@/components/nodeTypes/node--podcast--promoted--slider";
import PersonalizationBanner from "./personnalisez";
import { fetchApi, verifyUserConnexion } from "@/lib/utils";
import { NodePodcastHistorySlider } from "@/components/nodeTypes/node--podcast--history";

export default function MonComptePage() {
  const { data, status } = useSession()
  const router = useRouter()
  let skippedSub: string | null = typeof window !== "undefined" ? (localStorage.getItem('skippedSub') ? localStorage.getItem('skippedSub') : null) : null
  const [podcastItems, setPodcastItems] = useState<any[]>([])

  const [dataLoaded, setDataLoaded] = useState(false)
  const [podcastsPromotedFromThematics, setPromotedPodcast] = useState<DrupalNode[]>([])
  const [latestArticlesFromThematics, setLatestArticlesItems] = useState<DrupalNode[]>([])
  const [latestPodcastsFromEmissions, setLatestPodcastItems] = useState<DrupalNode[]>([])

  if (status !== "loading" && (!data?.user?.thematics || !data?.user?.podcasts) && !skippedSub) {
    typeof window !== "undefined" && router.push('/mon-compte/abonnements')
  }



  const hasData = () => {
    if (!dataLoaded) {
      return false
    }
    if (!podcastsPromotedFromThematics || !latestArticlesFromThematics || !latestPodcastsFromEmissions) {
      return true
    }
    if (podcastsPromotedFromThematics.length === 0 && latestArticlesFromThematics.length === 0 && latestPodcastsFromEmissions.length === 0) {
      return true
    }
    return false
  }

  useEffect(() => {
    const fetchMonCompteData = async () => {
      const thematics = data?.user?.thematics?.map(id => id.toString()) || [];
      const podcasts = data?.user?.podcasts?.map(id => id.toString()) || [];
      const response = await fetchApi(`/api/mon-compte`, {
        method: 'POST', headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ podcasts, thematics })
      })
      setPromotedPodcast(drupal.deserialize(response.podcastsFromThematics) as DrupalNode[])
      setLatestArticlesItems(drupal.deserialize(response.articlesFromThematics) as DrupalNode[])
      setLatestPodcastItems(drupal.deserialize(response.podcastsFromEmissions) as DrupalNode[])
      setDataLoaded(true)
    }
    if (data && data.user) {
      fetchMonCompteData()
    }
  }, [data])

  useEffect(() => {

    const fetctchData = async () => {
      const data = await fetchApi(`/api/user/history/podcasts-paginated?page=${0}&limit=${5}`, { method: 'GET' })
      setPodcastItems(data.data)
    }
    fetctchData()
  }, [])

  return (
    <LayoutAccount>

      <HeadMetadata
        title="Mon compte"
        description=""
      />

      <div className="bg-background">
        <Container>

          <div className="py-8">
            <AccountBannerComponent />
          </div>

        </Container>
      </div>

      {hasData() &&
        <Container>
          <PersonalizationBanner />
          <div className="py-16" />
        </Container>
      }

      {podcastsPromotedFromThematics && podcastsPromotedFromThematics.length > 0 && (
        <>
          <Container>
            <div className="py-6">
              <div className="mb-8">
                <h1 className="mb-2 text-5xl font-medium text-foreground-dark">Pour vous</h1>

                <p className='text-foreground-light mb-3'>Retrouvez ici le contenu lié à vos thématiques suivies.</p>
              </div>
              <p className='text-2xl text-foreground-dark mb-3'>Épisodes</p>
            </div>
          </Container>
          <div className="mb-8 w-full">
            <NodePodcastPromotedSlider
              podcasts={podcastsPromotedFromThematics}
            />
          </div>
        </>
      )}

      {latestArticlesFromThematics && latestArticlesFromThematics.length > 0 && (
        <>
          <Container>
            <p className='text-2xl text-foreground-dark mb-3'>Articles</p>
          </Container>
          <SlideshowNodes nodes={latestArticlesFromThematics} />
        </>
      )}

      <div className="bg-background">
        {latestPodcastsFromEmissions && latestPodcastsFromEmissions.length > 0 && (
          <>
            <Container>
              <div className="py-6">
                <p className='text-2xl text-foreground-dark mb-3'>Nouveaux épisodes</p>
              </div>
            </Container>
            <div className="mb-8 w-full">
              <NodePodcastPromotedSlider
                podcasts={latestPodcastsFromEmissions}
              />
            </div>
          </>
        )}
      </div>

      <div className="bg-background">
        {podcastItems && podcastItems.length > 0 && (
          <>
            <Container>
              <div className="py-6">
                <p className='text-2xl text-foreground-dark mb-3'>Écoutés récemment</p>
              </div>
            </Container>
            <div className="mb-8 w-full">
              <NodePodcastHistorySlider
                node={podcastItems}
              />
            </div>
          </>
        )}
      </div>
    </LayoutAccount>
  )
}

export async function getServerSideProps(context: GetServerSidePropsContext) {

  const authCheck = await verifyUserConnexion(context)
  if (authCheck) {
    return authCheck
  }

  return {
    props: {},
  }
}